<div class="d-flex flex-column mb-5">
  <span>Commande passée le : {{ commande.date | date: "dd/MM/yyyy" }}</span>
  <span>N° de commande : {{ commande.reference }}</span>
</div>

<div class="d-flex flex-column text-center mb-5">
  <span class="mb-5">
    Votre commande de crédits a bien été enregistrée. Cet achat figurera dans
    l'<a (click)="goToOrderHistory()">historique de vos commandes</a> et sur
    votre prochaine facture ADNOV. Vous pouvez d'ores et déjà profiter des
    services Perval.fr <br />
    Votre compte a été crédité et s'élève maintenant à :
  </span>
  <h6 class="text-black">{{ commande.totalCredit }} crédits disponibles</h6>
</div>

<div class="text-center mb-5">
  Si vous souhaitez des informations relatives à la commande ou la facturation,
  nous vous remercions de bien vouloir contacter le service client au 0 800 710
  620 ou
  <a href="mailto:serviceclient@adnov.fr"> serviceclient&#64;adnov.fr</a>
</div>
